import { CTA } from "@/components/CTA";
import { Reveal } from "@/components/Reveal";
import { PageHeader, Kicker } from "@/components/Section";
import { Marquee } from "@/components/Marquee";
import { Heart } from "@/components/Doodles";
import { CREATORS } from "@/data/characters";

export default function Village() {
  const serves = [
    { t: "Students & emerging creatives", b: "Build a portfolio on real briefs, not classroom exercises." },
    { t: "Founding cohort & talent", b: "Shape what the Village becomes and get seen for real work." },
    { t: "Schools & educators", b: "Bring experiential, project-based learning to your students." },
    { t: "Brands & sponsors", b: "Turn real business needs into supervised creative campaigns." },
    { t: "Mentors & pros", b: "Give back by guiding the next generation of creatives." },
  ];
  return (
    <div className="bg-onyx text-cream">
      <PageHeader
        kicker="The Village"
        titleLines={["A creative", "campus with", "no walls."]}
        subtitle="Big Little Village is a nonprofit creative movement. We exist to connect emerging creatives across disciplines and give them real, collaborative, portfolio-building experience."
      />

      <section className="grain-dark border-b border-gold/20 bg-charcoal py-20 sm:py-28">
        <div className="relative mx-auto grid max-w-[1400px] gap-12 px-4 sm:px-6 lg:grid-cols-2">
          <Reveal>
            <Kicker>Our Mission</Kicker>
            <h2 className="mt-5 font-display text-4xl uppercase leading-[0.9] tracking-tight text-metallic sm:text-5xl">
              Little ideas.<br />Big portfolios.<br /><span className="text-gold-metallic">Bigger futures.</span>
            </h2>
            <p className="mt-6 font-body text-lg leading-relaxed text-silver/85">
              We believe experience shouldn't be gatekept. By organizing emerging creatives into cohorts and
              handing them real creative briefs, we build the kind of portfolios that open doors — paid creative
              opportunities, freelance opportunities, agency opportunities, and employment pathways.
            </p>
            <p className="mt-4 font-body text-lg leading-relaxed text-silver/85">
              Completing a cohort is not a guarantee of employment. It's a real body of work, real collaboration,
              and real momentum.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="group panel-mono relative gold-frame overflow-hidden">
              <img src={CREATORS[1].img} alt="REEL — Film + Production, one of the BLV Universe cast" className="h-full max-h-[520px] w-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-onyx/60 to-transparent" />
              <span className="absolute bottom-3 left-3 font-mono text-[9px] uppercase tracking-[0.3em] text-goldlight/70">BLV / 002 — REEL</span>
            </div>
          </Reveal>
        </div>
      </section>

      <Marquee items={["Collaborate", "Create", "Contribute", "Big Little Village"]} reverse />

      <section className="grain-dark relative bg-onyx py-20 sm:py-28">
        <div className="halftone-gold pointer-events-none absolute inset-0 opacity-[0.03]" />
        <div className="relative mx-auto max-w-[1400px] px-4 sm:px-6">
          <Reveal><Kicker>Who We Serve</Kicker></Reveal>
          <div className="mt-10 grid gap-4 md:grid-cols-3">
            {serves.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.06}>
                <div className="group h-full border border-silver/20 bg-charcoal/60 p-6 transition-all duration-300 hover:border-gold/50 hover:shadow-[0_0_30px_rgba(201,162,39,0.12)]">
                  <Heart className="h-8 w-8" />
                  <h3 className="mt-4 font-head text-xl font-extrabold uppercase tracking-tight text-cream transition-colors group-hover:text-goldlight">{s.t}</h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-silver/75">{s.b}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2} className="mt-12">
            <CTA to="/apply" variant="pink">Find Your Place</CTA>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
